// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"496":"d0101a44","527":"c13dc3bd","653":"e146c5ef"}[chunkId] + ".css";
};